var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3540_6045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3994 17.0495C24.4936 17.2668 24.55 17.5041 24.55 17.7565C24.5501 18.08 24.4633 18.3977 24.2986 18.6762C24.134 18.9547 23.8976 19.1839 23.6141 19.3398L14.1526 24.5438L14.1413 24.55H14.1285H3.293H3.27229L3.25764 24.5354L0.772289 22.05H0.5H0.45V22V21V20.95H0.5H1.207H1.22771L1.24236 20.9646L3.72771 23.45H13.8587L23.0838 18.3767L24.3994 17.0495ZM24.3994 17.0495H24.5H24.55V16.9995V13.4995V13.4495H24.5H24.0353C23.7554 7.51819 18.9818 2.74462 13.05 2.46471V1.55H15.5H15.55V1.5V0.5V0.45H15.5H9.5H9.45V0.5V1.5V1.55H9.5H11.95V2.46471C6.01819 2.74462 1.24462 7.51819 0.964706 13.45H0.5H0.45V13.5V17V17.05H0.5H5.77229L7.25764 18.5354L7.27229 18.55H7.293H13C13.5239 18.55 13.95 18.9761 13.95 19.5C13.95 20.0239 13.5239 20.45 13 20.45H7.5H7.45V20.5V21.5V21.55H7.5H13.624H13.6364L13.6474 21.5442L21.9814 17.1322L21.9814 17.1322C22.0827 17.0785 22.1972 17.05 22.312 17.05H22.7429C22.8997 17.0503 23.0519 17.1026 23.1757 17.1988C23.2995 17.295 23.3878 17.4296 23.4269 17.5814C23.4659 17.7333 23.4534 17.8938 23.3913 18.0377C23.3292 18.1816 23.2211 18.3009 23.0839 18.3767L24.3994 17.0495ZM12.5 3.55C18.0764 3.55 22.6334 7.9439 22.9219 13.45H2.07806C2.36656 7.9439 6.9236 3.55 12.5 3.55ZM7.72771 17.45L7.32771 17.05H19.7857L15.0461 19.5591C15.0483 19.5404 15.05 19.5206 15.05 19.5C15.05 18.3694 14.1306 17.45 13 17.45H7.72771ZM22.312 15.95H1.55V14.55H23.45V15.95H22.312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3540_6045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitality);
export default __webpack_public_path__ + "static/media/Hospitality.75895b845472871907774fb35e1c4168.svg";
export { ForwardRef as ReactComponent };